import { render } from "./field_context_menu.vue?vue&type=template&id=46470a87"
import script from "./field_context_menu.vue?vue&type=script&lang=js"
export * from "./field_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/field_context_menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46470a87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46470a87', __exports__)) {
    api.reload('46470a87', __exports__)
  }
  
  module.hot.accept("./field_context_menu.vue?vue&type=template&id=46470a87", () => {
    api.rerender('46470a87', render)
  })

}


export default __exports__